// extracted by mini-css-extract-plugin
export default {"root":"aMfIL9Eo4R","header":"cQIveEvW0X"};